/* unplugin-vue-components disabled */import { render } from "./FormImage.vue?vue&type=template&id=57bb9f58&ts=true"
import script from "./FormImage.vue?vue&type=script&lang=ts"
export * from "./FormImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__